export default __webpack_public_path__ + "static/media/instantECardUsagehelpHighlight@2x.1e28550e.png";